<template>
  <PaymentsLayout>
    <router-view />
  </PaymentsLayout>
</template>
<script>
import PaymentsLayout from '@/views/Payments'

export default {
  name: 'PaymentsView',
  components: { PaymentsLayout }
}
</script>
